import Quill from 'quill';

export class CustomLinkModule {
    constructor() {
      const Link = Quill.import('formats/link');
  
      class CustomLink extends Link {
            static create(value) {
                const node = super.create(value);
                let url = node.getAttribute('href');
                
                if (url.startsWith(window.location.origin)) {
                    let cleanedUrl = url.substring(window.location.origin.length);
                    console.log(cleanedUrl);
                    node.setAttribute('href', cleanedUrl);
                }

                return node;
            }
      }
  
      Quill.register(CustomLink);
    }

  }
  